'use client';

import { useSyncExternalStore } from 'react';
import { type ConsentState, getConsentSnapshot, getServerConsentSnapshot, subscribeToConsent } from './consent-state';

/**
 * The consent answer for this visitor, re-rendering the caller when it changes (the click on the
 * banner, or the CMP resolving after mount). Denied and unresolved on the server and on the first
 * client render, so nothing vendor-related can render into the initial HTML.
 */
export function useConsent() {
  return useSyncExternalStore(subscribeToConsent, getConsentSnapshot, getServerConsentSnapshot);
}